﻿import { createApi } from "@reduxjs/toolkit/query/react";
import { fetchBaseQueryWrapper } from "./helpers";

export const dynamicFieldApi = createApi({
  reducerPath: "dynamicFieldApi",
  baseQuery: fetchBaseQueryWrapper({ baseUrl: "" }),
  endpoints: (build) => ({
    getDynamicAutoComplete: build.query({
      query: (url) => url,
      transformResponse: ({ data }) => data,
    }),
  }),
});

export const { useGetDynamicAutoCompleteQuery } = dynamicFieldApi;
